
// Update token expiry in state and everywhere else
import {
    useAuthStore,
    refreshBeforeMilliseconds,
    localStorageAuthExpiresKey
} from "@/stores/auth";
import {
    getStringFromStorage,
    setStringToStorage,
} from "@/stores/includes/storage";

/**
 * Update oauth tokens in all relevant places
 *
 * @param expiresAt
 */
export function updateTokenExpiry(expiresAt) {

    const now = new Date()
    const expiresIn = expiresAt - now.getTime()

    // Get state
    const auth = useAuthStore()

    // Cancel old refresh timer
    clearTimeout(auth.refreshFunctionId)

    // If expires in is a positive value (in can be negative, if resetted or not valid)
    if (expiresIn > 0) {
        // Refresh time + 0-10 seconds to avoid race conditions in multiple tabs while refreshing
        const refreshTime = expiresIn - refreshBeforeMilliseconds + (Math.random() * 10000)
        // Add timeout function for refreshing
        auth.refreshFunctionId = setTimeout(auth.refresh, refreshTime)
    }

    // We need to set these here ourself, since the update storage events are only called in different browser tabs
    auth.expiresAt = expiresAt

    // We need to set the accessToken FIRST because we listen on the expiresAt and therefore would call too EARLY
    setStringToStorage(localStorageAuthExpiresKey, expiresAt)

}

/**
 * Load tokens from local storage
 *
 * @returns {boolean}
 */
export function loadTokenExpiryFromStorage() {

    // const accessToken = getStringFromStorage(localStorageAccessTokenKey)
    const expiresAt = getStringFromStorage(localStorageAuthExpiresKey)

    // if (accessToken === null || expiresAt === null) return false
    if (expiresAt === null) return false

    updateTokenExpiry(expiresAt)

    return true
}